module.exports = __webpack_public_path__ + "static/media/StefanKuehne.86335c2d.jpg";